import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const ConfirmBox = ({ open, handleClose, confirmMsg, handleConfirm }) => {
  const [t] = useTranslation();

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          background: "#ffc115cb",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" component="span">
            {t("confirm.head")}
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: 3 }}>
        <Typography
          sx={{ padding: "0 0 15px 0" }}
          dangerouslySetInnerHTML={{ __html: confirmMsg }}
        ></Typography>
        <Button
          variant="contained"
          sx={{ marginRight: "5px" }}
          onClick={handleConfirm}
        >
          {t("confirm.yes")}
        </Button>
        <Button
          variant="outlined"
          sx={{ marginRight: "5px", color: "#000" }}
          onClick={handleClose}
        >
          {t("confirm.no")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmBox;
